import "./ProfilePage.scss";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { store } from "../../../../store/configureStore";
import * as accountActions from "../../../../store/actions/accountActions";
import { sendAccount } from "../../../../api/account";
import { Trans, withTranslation } from "react-i18next";
import images from "../../../../../src/ressources/images";
import InsInput from "../../../../components/InsInput/InsInput";
import InsCheckbox from "../../../../components/InsCheckbox/InsCheckbox";
import Validate from "../../../../ressources/validation";
import ValidatePassword from "../../../../components/ValidatePassword/ValidatePassword";
// import * as loadImage from "blueimp-load-image";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { connect } from "react-redux";
import * as language from "date-fns/locale";
import { XHRImage as Image } from "../../../../components/Media/Image";
import InsAutocomplete from "../../../../components/InsAutocomplete/InsAutocomplete";
import Select from "react-select";
import { autocomplete } from "../../../../api/account";
import { axiosApi } from "api/helper";

export class ProfilePageEdit extends Component {
  constructor(props) {
    super(props);

    const date = new Date();
    this.max_year = new Date(
      date.getFullYear() - 16,
      date.getMonth(),
      date.getDate()
    );
    this.min_year = new Date(
      date.getFullYear() - 100,
      date.getMonth(),
      date.getDate()
    );

    this.state = {
      account: this.props.account,
      profileDatas: { ...this.props.account, password: "" },
      passwordError: "",
      oldPasswordError: "",
      passwordConfirmError: "",
      birthdate: "",
      birthdateError: "",
      formError: "",
      editPassword: false,
      preview: false,
      cpError: false,
      phoneError: false,
      accountUpdated: false,
      brands: [],
      optins_link: {
        gdpr: this.props.config.register.opt_ins.ppFilePath
          ? this.props.config.register.opt_ins.ppFilePath
          : null,
        tou: this.props.config.register.opt_ins.touFilePath
          ? this.props.config.register.opt_ins.touFilePath
          : null,
      },
      shopEditMode: false,
      shopFields: [],
      shopAutocomplete: {},
      shopAcFocus: "",
      shopCountries: [],
      storeId: "",
    };
    this.handleChangeTimer = null;
    this.setTimeOutAutoComplete = null;
  }

  componentDidMount() {
    const brand_name = axiosApi(
      "get-user-profile-brands",
      {
        ba_type: this.state.account.ba_type,
        retailer_name: this.state.account.store[0].retailer,
      },
      "get"
    ).then((res) => {
      const brands = res.brands.sort((a, b) =>
        a.brand_name.localeCompare(b.brand_name)
      );
      this.setState({ brands: brands });
    });
    const datePickers = document.getElementsByClassName(
      "react-datepicker__input-container"
    );
    Array.from(datePickers).forEach((el) =>
      el.childNodes[0].setAttribute("readOnly", true)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { preview, profileDatas: { picture }, shopEditMode } = this.state;
    const { account: { picture: apiPicture } } = this.props;

    if (prevState.account !== this.props.account && !shopEditMode) {
      const previewImage = preview ? picture : apiPicture;
      this.setState({
        account: this.props.account,
        profileDatas: { ...this.state.profileDatas, ...this.props.account, picture: previewImage },
      });
    }
  }

  _shopFieldsToObject = () => {
    const { shopFields = [] } = this.state;
    return shopFields.reduce((acc, f) => {
      acc[f.name] = f.value;
      return acc;
    }, {});
  };

  handleBrandEdit = () => {
    this.setState({ brandEditMode: true, loading: false });
  };
  handleBrandChange = (index) => {
    this.setState((prevState) => {
      const newBrands = [...prevState.brands];
      newBrands[index].isSelected = !newBrands[index].isSelected;
      return { brands: newBrands };
    });
  };

  enableBrandEditSection = () => {
    const { t } = this.props;
    
    return (
      <div className="enable_brand_section">
        <div className="brand_section_header">
          <h3 className="brand_section_title">{t("profile_brands_label")}</h3>
        </div>
        <div className="brand_list">
          {this.state.brands.map((brand, index) => (
            <div key={brand.brand_name} className="brand_item">
              <input
                type="checkbox"
                id={`brand-${index}`}
                checked={brand.isSelected}
                onChange={() => this.handleBrandChange(index)}
                className="brand_checkbox"
              />
              <label
                htmlFor={`brand-${index}`}
                className={`brand_label ${brand.isSelected ? "checked" : ""}`}
              >
                {brand.brand_name}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  };

  /**
   * Envoie les informations du compte (informations stockées dans le state)
   */
  sendAccountDatas = (e) => {
    e.preventDefault();
    const { cpError, phoneError, profileDatas, shopEditMode, storeId } = this.state;
    const { password } = this.state.profileDatas;

    this.setState({ formError: "" });

    if (password !== "") {
      if (!this._validateOldPassword()) {
        return;
      }
    }

    if (shopEditMode) {
      profileDatas.store[0] = {
        ...this._shopFieldsToObject(),
        ...(storeId ? { id: storeId } : {}),
      };
    }

    const selectedBrandIds = this.state.brands
      .filter((b) => b.isSelected)
      .map((b) => String(b.brand_id));
      profileDatas.brands = selectedBrandIds;

    if (!cpError && !phoneError) {
      sendAccount(profileDatas)
        .then((data) => {
          this.accountUpdated();
          store.dispatch(accountActions.setAccountDatas(data));
          this.setState({ brandEditMode: false });
        })
        .catch((error) => {
          this.setState({ formError: error, shopEditMode: false });
        });
    }
  };

  accountUpdated = () => {
    this.setState({ accountUpdated: true, preview: false, shopEditMode: false });
    setTimeout(() => {
      this.setState({ accountUpdated: false });
    }, 3000);
  };

  /**
   * Change state datas input text
   */
  handleChange = (params) => (event) => {
    const value = event.target.value;

    this.setState((prevState) => ({
      profileDatas: {
        ...prevState.profileDatas,
        [params]: value,
      },
    }));
  };

  /**
   * Change state datas checkbox
   */
  _handleOptin = (input) => (e) => {
    const value = e.target.checked;

    this.setState((prevState) => ({
      profileDatas: {
        ...prevState.profileDatas,
        [input]: value,
      },
    }));
  };

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  loadImageUrl = async (input) => {
    const base64 = await this.toBase64(input.files[0]);
    this.setState({
      profileDatas: { ...this.state.profileDatas, picture: base64 },
      preview: true,
    });
  };

  /**
   * Change state datas input file (img)
   */
  onImageChange = async (event) => {
    if (event.target.files && event.target.files[0]) {
      this.loadImageUrl(event.target);
    }
    // Formdata avec un append 'avatar' de event.target.files pour une requête post avec le fichier directement (evol)
  };

  _handleBirthdate = (value, locale = false) => {
    if (value > this.max_year) {
      value = this.max_year;
    } else if (value < this.min_year) {
      value = this.min_year;
    }

    this.setState((prevState) => ({
      profileDatas: {
        ...prevState.profileDatas,
        birthdate: value,
      },
    }));
  };

  _phoneValidation = () => {
    const { profileDatas } = this.state;
    profileDatas.phone.length < 10
      ? this.setState({ phoneError: true })
      : this.setState({ phoneError: false });
  };

  _cpValidation = () => {
    const { profileDatas } = this.state;
    profileDatas.postal_code?.length < 5
      ? this.setState({ cpError: true })
      : this.setState({ cpError: false });
  };

  /**
   * Valide le champ password
   */
  _validatePassword = () => {
    const error = Validate("password", this.state.profileDatas.password);
    this.setState({
      passwordError: error,
    });
    return !error;
  };

  /**
   * Valide la confirmation du champ password
   */
  _validatePasswordConfirm = () => {
    const { password, passwordConfirm } = this.state.profileDatas;
    const { t } = this.props;
    if (
      password !== passwordConfirm &&
      !Validate("password", this.state.profileDatas.password)
    ) {
      this.setState({
        passwordConfirmError: t("error_password_not_same"),
      });
    } else {
      this.setState({
        passwordConfirmError: "",
      });
    }
    return password === passwordConfirm;
  };

  _validateOldPassword = () => {
    const { oldPassword } = this.state.profileDatas;
    const { t } = this.props;

    if (oldPassword === "") {
      this.setState({
        oldPasswordError: t("error_old_password_missing"),
      });
    } else {
      this.setState({
        oldPasswordError: "",
      });
    }

    return oldPassword !== "";
  };

  _editPassword = () => {
    this.setState({ editPassword: !this.state.editPassword });
  };

  editPicture = () => {
    this.refs["edit_picture"].click();
  };

  _renderDateFormat = (localLng) => {
    if (localLng === "en-GB" || localLng === "en-US" || localLng === "es-US")
      return "MM/dd/yyyy";
    return "dd/MM/yyyy";
  };

  initShopFields = () => {
    const { config } = this.props;
    const shopConfig = config.register.shop || [];
    const shopFields = shopConfig.map((field) => ({
      ...field,
      value: "",
      error: "",
      autocomplete: false,
    }));
    this.setState({
      shopFields,
      shopCountries: config.hub_countries || [],
      shopEditMode: true,
      shopAutocomplete: {},
    });
  };

  handleShopFieldChange = (input) => (e) => {
    const value = e.target.value;
    let { shopFields } = this.state;
    const index = shopFields.findIndex((el) => el.name === input);
    let newFields = [...shopFields];
    newFields[index].value = value;
    if (!newFields[index].value.length) {
      this.clearShopForm();
    } else {
      this.setState(
        {
          shopAcFocus: input,
          shopFields: newFields,
        },
        () => {
          if (value.length >= 1) {
            if (this.handleChangeTimer) {
              clearTimeout(this.handleChangeTimer);
            }
            this.handleChangeTimer = setTimeout(() => {
              this.shopAutocompleteRequest();
            }, 500);
          }
        }
      );
    }
  };

  shopAutocompleteRequest = (generation = false) => {
    const { shopFields } = this.state;
    let obj = {};
    shopFields.forEach((field) => {
      if (field.value.length) {
        obj[field.name] = field.value.trim();
      }
    });

    autocomplete(obj)
      .then((data) => {
        this.setState({ shopAutocomplete: data });

        if (generation) {
          let newFields = [...shopFields];
          Object.keys(data).forEach((item) => {
            const index = newFields.findIndex((el) => el.name === item);
            if (index < 0) return;

            if (data[item] && data[item].length === 1) {
              if (item === "country") {
                newFields[index].value = data[item][0].value;
              } else {
                newFields[index].value = data[item][0];
              }
              newFields[index].autocomplete = true;
            }
            this.setState({ shopFields: newFields, storeId: data.id }, () => {
              newFields.forEach((el) => this._validateShopField(el.name)(true));
            });
          });
        }
      })
      .catch(() => {
        this.setState({ shopAutocomplete: {} });
      });
  };

  showShopAutocomplete = (name) => () => {
    clearTimeout(this.setTimeOutAutoComplete);
    this.setState({ shopAcFocus: name });
  };

  handleShopAutocompleteClick = (input) => (value) => {
    let { shopFields } = this.state;
    const index = shopFields.findIndex((el) => el.name === input);
    let newFields = [...shopFields];
    newFields[index].value = value;
    newFields.forEach((el) => {
      el.autocomplete = true;
    });
    this.setState(
      {
        shopFields: newFields,
        shopAcFocus: "",
      },
      () => {
        this.shopAutocompleteRequest(true);
      }
    );
  };

  clearShopForm = () => {
    const { config } = this.props;
    const shopConfig = config.register.shop || [];
    let initialState = {
      shopAutocomplete: {},
      shopAcFocus: "",
      shopFields: shopConfig.map((field) => ({
        ...field,
        value: "",
        error: "",
        autocomplete: false,
      })),
      shopCountries: config.hub_countries || [],
    };
    this.setState(initialState);
  };

  _validateShopField =
    (input) =>
    (displayError = true) => {
      const { shopFields } = this.state;
      const index = shopFields.findIndex((el) => el.name === input);
      if (!shopFields[index].required) {
        return true;
      }
      const error =
        Validate("required", shopFields[index].value) ||
        Validate(shopFields[index].name, shopFields[index].value);
      if (displayError) {
        let newFields = [...shopFields];
        newFields[index].error = error;
        this.setState({
          shopFields: newFields,
        });
      }
      return !error;
    };

  _validateShopFormStep = () => {
    const { shopFields } = this.state;
    return shopFields.every((el) => this._validateShopField(el.name)(false));
  };

  handleShopCountry = (option) => {
    const { config } = this.props;
    const shopConfig = config.register.shop || [];
    let newFields = shopConfig.map((field) => ({
      ...field,
      value: field.name === "country" ? option.value : "",
      error: "",
    }));
    this.setState({ shopFields: newFields }, () => {
      this._validateShopField("country")();
      this.shopAutocompleteRequest();
    });
  };

  _shopFieldAddress = (field) => {
    const { t } = this.props;
    const { shopAcFocus, shopAutocomplete } = this.state;
    return (
      <div className="input_container">
        <InsInput
          name={field.name}
          onChange={this.handleShopFieldChange(field.name)}
          onFocus={this.showShopAutocomplete(field.name)}
          onBlur={() => {
            this._validateShopField(field.name)();
            this.setTimeOutAutoComplete = setTimeout(() => {
              this.setState({ shopAcFocus: "" });
            }, 300);
          }}
          maxLength="115"
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value}
          autoComplete={"off"}
          readOnly
          error={field.error}
        />
        <InsAutocomplete
          visible={shopAcFocus === field.name}
          values={shopAutocomplete[field.name]}
          onClick={this.handleShopAutocompleteClick(field.name)}
        />
        {field.autocomplete || field.value.length ? (
           <div
            className="clear_input"
            onClick={() => this.clearShopForm()}
          >
            &#10006;
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  _shopFields = (field) => {
    const { t, config } = this.props;
    const { shopAutocomplete, shopAcFocus } = this.state;

    return (
      <div className="input_container">
        <InsInput
          name={field.name}
          onChange={this.handleShopFieldChange(field.name)}
          onFocus={this.showShopAutocomplete(field.name)}
          onBlur={() => {
            this._validateShopField(field.name)();
            this.setTimeOutAutoComplete = setTimeout(() => {
              this.setState({ shopAcFocus: "" });
            }, 300);
          }}
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value}
          autoComplete={"off"}
          error={field.error}
          readOnly={field.autocomplete}
          country={config.country}
        />
        <InsAutocomplete
          visible={shopAcFocus === field.name}
          values={shopAutocomplete[field.name]}
          onClick={this.handleShopAutocompleteClick(field.name)}
        />
        {field.autocomplete || field.value.length ? (
          <div
            className="clear_input"
            onClick={() => this.clearShopForm()}
          >    
            &#10006;
          </div>
        ) : (
          ""
        )}
        {config.country === "SPAIN" && field.name === "retailer" && (
          <div className="field_note">{t('register_retailer_helper')}</div>
        )}
      </div>
    );
  };

  _shopFieldCountry = (field) => {
    const { t } = this.props;
    const { shopFields, shopCountries } = this.state;
    const index = shopFields.findIndex((el) => el.name === field.name);
    let newFields = [...shopFields];

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor: "white",
        color: "black",
      }),
      control: (provided, state) => ({
        ...provided,
        backgroundColor: "transparent",
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "black",
      }),
    };

    shopCountries.map((country) => (country.label = country.name));

    return (
      <div className={field.error ? "ins_input mb20 error country_field" : "ins_input mb20 country_field"}>
        <Select
          isSearchable={false}
          classNamePrefix={field.name}
          menuPlacement="bottom"
          styles={customStyles}
          className={field.name}
          value={{
            value: newFields[index].value,
            label: (
              <div className="ls-row">
                {newFields[index].value
                  ? shopCountries.find(
                      (country) => country.value === newFields[index].value
                    )?.label
                  : newFields[index].required
                  ? t(field.name) + " *"
                  : t(field.name)}
              </div>
            ),
          }}
          onChange={this.handleShopCountry}
          options={shopCountries}
        />
        {field.error && (
          <div className={"error-" + field.name}>{field.error}</div>
        )}
      </div>
    );
  };

  renderShopEditableFields = () => {
    const { t } = this.props;
    const { shopFields } = this.state;
    return (
      <div className="shop_edit">
        <p className="bold-label centered mb50">{t("step1")}</p>
        <div className="close_icon round_border_icon" role="button" onClick={() => this.setState({ shopEditMode: false })}></div>
        {shopFields.map((field) => {
          switch (field.name) {
            case "address":
              return <div key={field.name}>{this._shopFieldAddress(field)}</div>;
            case "country":
              if (this.state.shopCountries.length < 2) {
                return <div key={field.name}></div>;
              }
                return <div key={field.name}>{this._shopFieldCountry(field)}</div>;
            default:
              return <div key={field.name}>{this._shopFields(field)}</div>;
          }
        })}
        <div className="bottom-container">
          {!this._validateShopFormStep() && (
            <div className="alert_msg mb10">{t("required")}</div>
          )}
        </div>
      </div>
    );
  };

  renderBrandsViewSection = () => {
    const { t } = this.props;
    const selectedBrands = this.state.brands.filter((b) => b.isSelected);

    return (
      <div
        className="enable_brand_section brands_readonly_section"
      >
        <div className="brand_section_header">
          <h3 className="brand_section_title">{t("profile_brands_label")}</h3>
        </div>
        <div className="brand_list readonly">
          {selectedBrands.length === 0 ? (
            <div className="brands_empty">{t("select_brands")}</div>
          ) : (
            selectedBrands.map((brand, index) => (
              <div key={brand.brand_name} className="brand_item">
                <input
                  type="checkbox"
                  checked={true}
                  disabled
                  className="brand_checkbox"
                  id={`brand-view-${index}`}
                />
                <label
                  htmlFor={`brand-view-${index}`}
                  className="brand_label checked"
                >
                  {brand.brand_name}
                </label>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  render() {
    const { config, t, i18n, account } = this.props;
    const { person, shop, connect } = config.register;
    const {
      country,
      features: {
        enable_account_retailer_store = false,
        enable_account_brands = false,
      },
    } = config;
    const {
      accountUpdated,
      cpError,
      editPassword,
      phoneError,
      profileDatas,
      passwordConfirmError,
      passwordError,
      oldPasswordError,
      preview,
      formError,
      optins_link,
      shopEditMode,
      brandEditMode,
    } = this.state;
    const { birthdate, firstname, lastname, password, picture, optin_wall } =
      profileDatas;

    let locale = i18n.language.replace(/-/g, "");
    let fullLocal = i18n.language;

    const languages = Object.keys(language);
    if (!languages.includes(locale)) {
      locale = locale.substring(0, 2);
      if (!languages.includes(locale)) {
        locale = "fr";
      }
    }

    registerLocale(`${locale}`, language[locale]);
    setDefaultLocale(`${locale}`);

    const canRetailerShopEditable =
      enable_account_retailer_store && account.ba_type === "EXTERNAL_BA";
    const canBrandsEditable =
      enable_account_brands && account.ba_type === "EXTERNAL_BA";

    const saveBtnStatus = shopEditMode
      ? !this._validateShopFormStep() || phoneError || cpError
      : phoneError || cpError;

    return (
      <div className="bg_white">
        <form onSubmit={this.sendAccountDatas} className="profile_container">
          <div className="column_center">
            <Link
              to={{
                pathname: "/profile",
                state: { transitionName: "slide_out" },
              }}
              className="back_link"
            ></Link>
            <div onClick={this.editPicture} className="profil_picture">
              {preview ? (
                <img src={picture} alt="preview" />
              ) : picture ? (
                <Image src={picture} alt="" />
              ) : (
                <img src={images.icon_user} alt="" />
              )}
            </div>
            <div className="input_file">
              <label htmlFor="file" className="label-file">
                {t("change_avatar")}
              </label>
              <input
                ref="edit_picture"
                type="file"
                accept="image/*"
                onChange={this.onImageChange}
              />
            </div>
          </div>
          <div className="send_wrapper">
            <div className="can_edit">
              {person[person.findIndex((el) => el.name === "firstname")] && (
                <InsInput
                  name="firstname"
                  type="text"
                  placeholder={t("firstname")}
                  value={firstname ? firstname : ""}
                  disabled
                />
              )}

              {person[person.findIndex((el) => el.name === "lastname")] && (
                <InsInput
                  name="lastname"
                  type="text"
                  placeholder={t("lastname")}
                  value={lastname ? lastname : ""}
                  disabled
                />
              )}

              {person[person.findIndex((el) => el.name === "birthdate")] && (
                <DatePicker
                  selected={birthdate ? new Date(birthdate) : ""}
                  onChange={(value) => this._handleBirthdate(value, fullLocal)}
                  placeholderText={t("birthdate")}
                  minDate={this.min_year}
                  maxDate={this.max_year}
                  dateFormat={language[locale].formatLong.date({
                    width: "short",
                  })}
                  locale={locale}
                  className="ins_input ins_datePicker"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  popperPlacement="top-center"
                />
              )}
              {person[person.findIndex((el) => el.name === "user_address")] && (
                <InsInput
                  name="address"
                  type="text"
                  placeholder={t("address")}
                  value={profileDatas.address ? profileDatas.address : ""}
                  onChange={this.handleChange("address")}
                  maxLength="115"
                />
              )}
              {person[person.findIndex((el) => el.name === "user_address")] && (
                <InsInput
                  name="city"
                  type="text"
                  placeholder={t("city")}
                  value={profileDatas.city ? profileDatas.city : ""}
                  onChange={this.handleChange("city")}
                />
              )}
              {person[person.findIndex((el) => el.name === "user_address")] && (
                <>
                  <InsInput
                    name="postal_code"
                    type="number"
                    onInput={(e) => {
                      e.target.value = e.target.value.slice(0, 5);
                    }}
                    maxLength="5"
                    placeholder={t("postal_code")}
                    value={
                      profileDatas.postal_code ? profileDatas.postal_code : ""
                    }
                    onChange={this.handleChange("postal_code")}
                    onBlur={this._cpValidation}
                  />
                  {cpError && (
                    <div
                      className={cpError ? "phone_error mb20" : "phone_error"}
                    >
                      {t("cp_error")}
                    </div>
                  )}
                </>
              )}

              {connect[connect.findIndex((el) => el.name === "phone")] && (
                <>
                  <InsInput
                    className={phoneError ? "mb0" : "mb20"}
                    name="phone"
                    type="tel"
                    placeholder={t("phone")}
                    value={profileDatas.phone ? profileDatas.phone : ""}
                    onChange={this.handleChange("phone")}
                  />
                  {phoneError && (
                    <div
                      className={
                        phoneError ? "phone_error mb20" : "phone_error"
                      }
                    >
                      {t("phone_number_error")}
                    </div>
                  )}
                </>
              )}

              {!editPassword && (
                <div
                  className="edit_password"
                  onClick={() => this._editPassword()}
                >
                  {t("password_change")}
                </div>
              )}
              {editPassword && (
                <div>
                  <InsInput
                    name="password"
                    type="password"
                    placeholder={t("new_password")}
                    onChange={this.handleChange("password")}
                    error={passwordError}
                  />
                  <InsInput
                    name="passwordConfirm"
                    type="password"
                    placeholder={t("password_confirm")}
                    onChange={this.handleChange("passwordConfirm")}
                    onBlur={this._validatePasswordConfirm}
                    error={passwordConfirmError}
                  />
                  <InsInput
                    name="oldPassword"
                    type="password"
                    placeholder={t("current_password")}
                    onChange={this.handleChange("oldPassword")}
                    onBlur={this._validateOldPassword}
                    error={oldPasswordError}
                  />
                  <div className="profil-validate-password">
                    <ValidatePassword value={password} activeColor="#32CD32">
                      {t("help_password")}
                    </ValidatePassword>
                  </div>
                </div>
              )}
              {/* <input type="text" placeholder="Date de naissance" value='07/10/90' /> Infos manquante */}
              <InsCheckbox
                label={
                  <Trans i18nKey="optin_wall_profil">
                    By posting content on One Retail I agree to the
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={optins_link.tou}
                    >
                      Terms of Use
                    </a>
                    governing the rights granted to L’Oréal {country} on such
                    content and to the use of my personal data in order for
                    L’Oréal {country} to publish and manage my post in the
                    condition of the
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={optins_link.gdpr}
                    >
                      Privacy Policy.
                    </a>
                    <br />
                    <br />
                    You may delete your content at any time in your personal
                    account.
                  </Trans>
                }
                name="optin_wall"
                onClick={this._handleOptin("optin_wall")}
                checked={optin_wall}
              />
            </div>

            {!shopEditMode && (
              <div className="cant_edit">
                {canRetailerShopEditable && <div className="edit_icon round_border_icon" role="button" onClick={() => this.initShopFields()}></div>}
                <div className="input_group_label">Retailer</div>

                <InsInput
                  name="retailer_name"
                  type="text"
                  placeholder={t("retailer_name")}
                  value={
                    profileDatas.store[0].retailer
                      ? profileDatas.store[0].retailer
                      : ""
                  }
                  disabled
                />

                <div className="input_group_label">Shop</div>

                <InsInput
                  name="shop_code"
                  type="text"
                  placeholder={t("shop_code")}
                  value={
                    profileDatas.store[0].code
                  }
                  disabled
                />
                <InsInput
                  name="shop_name"
                  type="text"
                  placeholder={t("shop_name")}
                  value={
                    profileDatas.store[0].name
                      ? profileDatas.store[0].name
                      : profileDatas.store[0].retailer
                      ? profileDatas.store[0].retailer
                      : ""
                  }
                  disabled
                />
                <InsInput
                  name="address"
                  type="text"
                  placeholder={t("address")}
                  value={profileDatas.store[0] ? profileDatas.store[0].address : ""}
                  disabled
                />
                <InsInput
                  name="city"
                  type="text"
                  placeholder={t("city")}
                  value={profileDatas.store[0] ? profileDatas.store[0].city : ""}
                  disabled
                />
                <InsInput
                  name="city"
                  type="text"
                  placeholder={t("city")}
                  value={profileDatas.store[0] ? profileDatas.store[0].country : ""}
                  disabled
                />
              </div>
            )}

            {shopEditMode && this.renderShopEditableFields()}

            {!canRetailerShopEditable && !canBrandsEditable && (
              <p className="profile-edit-bottom-text">
                {t("profile_edit_bottom_text")}
              </p>
            )}

            {canBrandsEditable && (
              <div className={`brands_section ${brandEditMode ? "edit_mode" : "view_mode"}`}>
                {!brandEditMode && (
                  <div
                    className="edit_icon round_border_icon"
                    onClick={this.handleBrandEdit}
                    role="button"
                  ></div>
                )}

                {brandEditMode && (
                  <div
                    className="close_icon round_border_icon brand_close_icon"
                    role="button"
                    onClick={() => this.setState({ brandEditMode: false })}
                    aria-label="Close"
                  ></div>
                )}
                {brandEditMode ? (
                  <>{this.enableBrandEditSection()}</>
                ) : (
                  <>
                      {this.renderBrandsViewSection()}
                  </>
                )}
              </div>
            )}
            {!canRetailerShopEditable && canBrandsEditable && (
              <p className="profile-edit-bottom-text top-margin">
                {t("profile_edit_bottom_text")}
              </p>
            )}
          </div>

          <div className="last_form">
            {accountUpdated && (
              <div className="account_updated">{t("account_updated")}</div>
            )}
            {formError && (
              <div className="account_updated fail">{t(formError)}</div>
            )}
            <input
              className="register"
              type="submit"
              disabled={saveBtnStatus}
              value={t("save")}
            />
            <input
              className="reset"
              type="reset"
              value={t("cancel")}
              onClick={() => this.props.history.goBack()}
            />
          </div>
        </form>
      </div>
    );
  }
}

//extract data from the redux store
const mapStateToProps = (state) => ({
  account: state.account,
  config: state.config,
  auth: state.auth,
});

export default connect(mapStateToProps)(
  withTranslation()(ProfilePageEdit)
);